import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface cancelledPaymentFilterState {
  startDate: string;
  endDate: string;
  categoryId: string;
}

const initialState: cancelledPaymentFilterState = {
  startDate: "",
  endDate: "",
  categoryId: "",
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("cancelledPaymentFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
    }
  : initialState;

const cancelledPaymentFilterSlice = createSlice({
  name: "cancelledPaymentFilter",
  initialState: persistedState,
  reducers: {
    setCancelledPaymentFilter(
      state,
      action: PayloadAction<Partial<cancelledPaymentFilterState>>
    ) {
      Object.assign(state, action.payload);
      localStorage.setItem("cancelledPaymentFilter", JSON.stringify(state));
    },
    resetCancelledPaymentFilter() {
      localStorage.removeItem("cancelledPaymentFilter");
      return initialState;
    },
  },
});

export const { setCancelledPaymentFilter, resetCancelledPaymentFilter } =
  cancelledPaymentFilterSlice.actions;

export default cancelledPaymentFilterSlice.reducer;
